import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ApolloClient, InMemoryCache, ApolloProvider, split, HttpLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from '@apollo/client/link/ws';
import { BrowserRouter as Router } from 'react-router-dom';
import { host, sentry_dsn } from './config';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: sentry_dsn,
  tracesSampleRate: 0.7,
});

const protocol_suffix = (process.env.NODE_ENV === 'development') ? '' : 's';

const ws_link = new WebSocketLink({
  uri: `ws${protocol_suffix}://${host}/graphql`,
  options: {
    reconnect: true,
  }
});

const http_link = new HttpLink({
  uri: `http${protocol_suffix}://${host}/graphql`,
});

const link = split(
  ({ query }) => {
    const def = getMainDefinition(query);
    return (def.kind === 'OperationDefinition' && def.operation === 'subscription');
  },
  ws_link,
  http_link,
);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    typePolicies: {
      Fight: { keyFields: false },
      EncounterStats: { keyFields: ['team', 'encounterId', 'difficulty']},
      Log: { keyFields: ['iid'] },
      Team: { keyFields: ['iid'] },
    }
  }),
});

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={"An error has occurred."} showDialog>
      <ApolloProvider client={client}>
        <Router>
          <App />
        </Router>
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
